var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tree-container" } },
    [
      _c("span", [_vm._v(" " + _vm._s(_vm.tree.menuTitle) + " ")]),
      _vm._l(_vm.tree.items, function (item, index) {
        return _c("data-tree-element", {
          key: index,
          attrs: { element: item },
          on: {
            "label-click": _vm.handleLabelSelect,
            "remove-selected": _vm.removeSelected,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }